import { mapState, mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapState('solution', ['id', 'config', 'type', 'language']),
        ...mapGetters('solution', ['hasCasting', 'isCasting', 'homeSteps', 'showUploadInformation', 'showHomeSteps', 'showUserVideos', 'briefSteps', 'briefRules']),
        configStyles () {
            return {
                primary: {
                    text: {
                        color: this.config.COLOR_PRIMARY,
                    },
                    background: {
                        backgroundColor: this.config.COLOR_PRIMARY,
                    },
                },
                secondary: {
                    text: {
                        color: this.config.COLOR_SECONDARY,
                    },
                    background: {
                        backgroundColor: this.config.COLOR_SECONDARY,
                    },
                },
            };
        },
    },
    methods: {
        ...mapActions('solution', ['updateSolution']),
    },
};
